import { futureDateFn } from "helpers";

export const SetFutureDate = (text = "", envs: Record<string, any> | null) => {
  text = text?.replaceAll("FUTURE_DATE_6M", `${futureDateFn(6)}`);
  text = text?.replaceAll("FUTURE_DATE_4M", `${futureDateFn(4)}`);
  text = text?.replaceAll("FUTURE_DATE_3M", `${futureDateFn(3)}`);
  text = text?.replaceAll("SELF_LINK", `${envs?.hostUrl?.replace("developer", "api")}`);

  return text;
};


export function DocumentModifier(docText: string, envs: Record<string, string | undefined>) {
  const replacements: [RegExp, string | undefined][] = [

    [/AUTH_HOST/, envs?.authApi?.replace(/^https:\/\/auth\./, "*.")],
  ];

  if (typeof docText === "string") {
    for (const [regex, value] of replacements) {
      if (value) {
        docText = docText.replace(regex, value);
      }
    }

    return docText;
  }
  return null;
}
